import styled from 'styled-components';
import { rem } from 'polished';
import { P } from '~typography';
var MissionContentContainer = styled(P).withConfig({
  displayName: "MissionContentContainer",
  componentId: "s8uiz3-0"
})(["margin:", " 0;"], rem(8));
export default MissionContentContainer;